/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Table,
  Container,
  Card
} from 'react-bootstrap'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import AlertIcon from '../../components/atoms/Icons/AlertIcon'
import CustomCloseButton from '../../components/Button/CustomCloseButton'
import CustomButton from '../../components/Button/CustomButton'
import api from '../../config/AxiosInstance'
import { capitalizeFirstLetter } from '../../helpers/constants'
import Loading from '../../components/atoms/Loading'
import { Plus } from 'lucide-react'
import SelectInput from '../../components/Input/SelectInput'
import toast, { Toaster } from 'react-hot-toast'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

function CreateStockTake() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [visible, setVisible] = useState({
    save: false,
    cancel: false,
    selectPicChecker: false
  })
  const [options, setOptions] = useState({
    pics: [],
    checkers: []
  })
  const [loading, setLoading] = useState({
    page: false,
    submit: false
  })
  const [data, setData] = useState([])
  const [selectedRacks, setSelectedRacks] = useState([])
  const [selectedForm, setSelectedForm] = useState({
    pic: null,
    checker: null
  })
  const fetchRacks = async () => {
    try {
      setLoading({
        ...loading,
        page: true
      })
      const payload = {
        warehouse_id: state?.warehouse_id,
        type: state?.type || 'warehouse',
        item_codes: state?.item_codes || []
      }
      const res = await api.post('/stock-opname/racks', payload)
      const { status, data: dataRes } = res
      if (status === 200) {
        const { data } = dataRes
        setData(data.map((item) => ({ ...item, checker_id: '', pic_id: '' })))
        setOptions({
          pics: state.pic,
          checkers: state.checker
        })
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading({
        ...loading,
        page: false
      })
    }
  }
  const renderSelect = (dataValue, type) => {
    const values = type === 'Checker' ? options.checkers : options.pics
    return (
      <Form.Select
        aria-label={`Select ${type}`}
        value={type === 'Checker' ? dataValue.checker_id : dataValue.pic_id}
        onChange={(e) => {
          const { value } = e.target
          setData((prevData) =>
            prevData.map((item) => {
              if (item.id === dataValue.id) {
                return {
                  ...item,
                  [type === 'Checker' ? 'checker_id' : 'pic_id']: value
                }
              }
              return item
            })
          )
        }}
      >
        <option value="">Select {type}</option>
        {values?.map((value, index) => (
          <option key={index} value={value.value}>
            {value.label}
          </option>
        ))}
      </Form.Select>
    )
  }
  const handleCheckbox = (value = 'all') => {
    if (value === 'all') {
      const racks =
        data?.map((item) => {
          return {
            id: item?.id,
            rack_name: item?.name
          }
        }) || []
      if (racks?.length === selectedRacks?.length) {
        setSelectedRacks([])
      } else {
        setSelectedRacks(racks)
      }
    } else {
      if (selectedRacks?.find((item) => item?.id === value?.id)) {
        setSelectedRacks((prev) => prev.filter((item) => item.id !== value?.id))
      } else {
        setSelectedRacks((prev) => [
          ...prev,
          {
            id: value?.id,
            rack_name: value?.name
          }
        ])
      }
    }
  }
  const getRackNameSelected = useMemo(() => {
    return selectedRacks?.map((item) => item?.rack_name).join(', ')
  }, [selectedRacks])
  const ModalPropMemo = useMemo(() => {
    if (visible.save) {
      return {
        key: 'save',
        headerTitle: '',
        title: 'Create?',
        body: 'Make sure to assign checker and PIC to rack properly!'
      }
    }
    if (visible.cancel) {
      return {
        key: 'cancel',
        headerTitle: '',
        title: 'Cancel?',
        body: 'All data will be deleted, cancel creating ticket?'
      }
    }
    if (visible.selectPicChecker) {
      return {
        key: 'selectPicChecker',
        headerTitle: 'Select Checker and PIC',
        title: '',
        body: ''
      }
    }
    return {
      key: '',
      headerTitle: '',
      title: '',
      body: ''
    }
  }, [visible])
  const columns = [
    {
      key: 'checkbox',
      label: '',
      component: (value) => (
        <div key={value?.id} className="d-flex justify-content-center">
          <input
            type="checkbox"
            role="button"
            className="staging-area form-check-input"
            onChange={() => handleCheckbox(value)}
            style={{ cursor: 'pointer' }}
            checked={selectedRacks?.find((item) => item?.id === value?.id)}
          />
        </div>
      )
    },
    { key: 'name', label: 'Layer' },
    {
      key: 'type',
      label: 'Rack Type',
      component: (data) => capitalizeFirstLetter(data.type)
    },
    { key: 'total_slot', label: 'Total Slot' },
    {
      key: 'checker',
      label: 'Checker',
      component: (data) => renderSelect(data, 'Checker')
    },
    {
      key: 'pic',
      label: 'PIC',
      component: (data) => renderSelect(data, 'PIC')
    }
  ]

  const propertyBtnSave = () => {
    const submitted = data.some(
      (item) =>
        !item.checker_id ||
        item.checker_id === '' ||
        !item.pic_id ||
        item.checker_id === ''
    )
    if (submitted) {
      return {
        variant: 'transparent',
        size: 'md',
        className: 'btn-secondary opacity-25 cursor-not-allowed',
        disabled: true
      }
    }
    return {
      variant: 'transparent',
      size: 'md',
      className: 'btn-primary-orange',
      disabled: false,
      onClick: () => {
        setVisible({ ...visible, save: true })
      }
    }
  }

  const handleCloseModal = (type) => {
    setVisible({ ...visible, [type]: false })
    if (type === 'selectPicChecker') {
      setSelectedForm({ pic: null, checker: null })
    }
  }

  const propertyBtnCancel = () => {
    let text = ''
    const modalVisibleKey = Object.keys(visible).find(
      (key) => visible[key] === true
    )
    if (modalVisibleKey === 'save') {
      text = 'Continue Assign'
    } else if (modalVisibleKey === 'cancel') {
      text = 'Continue Creating'
    }
    return {
      onClick: () => {
        setVisible({ ...visible, [modalVisibleKey]: false })
      },
      text
    }
  }
  const handleSubmit = async () => {
    try {
      setLoading({
        ...loading,
        submit: true
      })
      const payload = {
        warehouse_id: state?.warehouse_id,
        type: 'stock_take',
        opname_type: state?.type || 'warehouse',
        item_codes: state?.item_codes || [],
        racks: data.map((item) => ({
          id: item.id,
          rack: item.name,
          checker_id: item.checker_id,
          pic_id: item.pic_id
        }))
      }
      const res = await api.post('/stock-opname', payload)
      const { status, data: dataRes } = res
      if (status === 200) {
        toast.success('Stock take created!', {
          position: 'top-right',
          style: { fontSize: '14px', fontWeight: '600' }
        })
        navigate('/stock-opname/stock-take', { replace: true, state: null })
      } else {
        throw new Error(dataRes.message)
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message ||
        err?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading({
        ...loading,
        submit: false
      })
    }
  }
  const propertyBtnSubmit = () => {
    let text = ''
    const modalVisibleKey = Object.keys(visible).find(
      (key) => visible[key] === true
    )
    if (modalVisibleKey === 'cancel') {
      text = 'Cancel'
    } else if (modalVisibleKey === 'save') {
      text = 'Create'
    }
    return {
      text,
      variant: 'transparent',
      classNameValue:
        loading.submit ||
        data.some(
          (item) =>
            !item.checker_id ||
            item.checker_id === '' ||
            !item.pic_id ||
            item.checker_id === ''
        )
          ? visible.cancel
            ? 'text-white btn-primary-orange'
            : 'btn-secondary opacity-25'
          : 'text-white btn-primary-orange',

      disabled: loading.submit,
      onClick: () => {
        setVisible({ ...visible, [modalVisibleKey]: true })
        if (modalVisibleKey === 'save') {
          handleSubmit()
        } else if (visible.cancel) {
          toast.success('Cancel create stock opname!', {
            position: 'top-right',
            style: { fontSize: '14px', fontWeight: '600' }
          })
          navigate('/stock-opname/stock-take', { replace: true, state: null })
        }
      }
    }
  }

  const handlingSavingBulk = () => {
    const selectedRackIds = selectedRacks.map((item) => item.id) || []
    setData((prev) => {
      return prev.map((item) => {
        if (selectedRackIds.includes(item.id)) {
          return {
            ...item,
            checker_id: selectedForm.checker,
            pic_id: selectedForm.pic
          }
        }
        return item
      })
    })
    setSelectedRacks([])
    handleCloseModal('selectPicChecker')
  }

  useEffect(() => {
    if (state) {
      fetchRacks()
    } else {
      navigate('/stock-opname/stock-take', { replace: true, state: null })
      toast.error('Data not found, please check and try again', {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    }
  }, [state])
  if (loading.page) {
    return <Loading />
  }
  return (
    <Container fluid className="px-4">
      <Toaster />
      <Row className="mb-4 align-items-center">
        <Col md={12}>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h3 style={headerTitleStyle}>Stock Take</h3>
            </div>
            <div className="d-flex gap-2 justify-content-end align-items-center">
              <div className="d-flex align-items-center justify-content-center me-3">
                <p className="text-danger fw-bold mb-0">
                  Please select checker and PIC to create ticket
                </p>
              </div>
              <Button
                variant="light"
                className="text-secondary fw-bold px-3 border"
                onClick={() => {
                  setVisible({ ...visible, cancel: true })
                }}
              >
                Cancel
              </Button>
              <Button {...propertyBtnSave()}>Save</Button>
            </div>
          </div>
        </Col>
      </Row>
      <Card style={cardStyle}>
        <Row>
          <Col md={12}>
            {selectedRacks?.length > 0 && (
              <Row>
                <Col md={12} className="mb-3">
                  <div className="d-flex gap-3 align-items-center">
                    <p className="fw-bold mb-0">
                      {selectedRacks?.length} Rack Selected
                    </p>
                    <div
                      style={{
                        height: '16px',
                        width: '2px',
                        backgroundColor: '#dee2e6'
                      }}
                    />
                    <button
                      className="border-0 bg-transparent p-0"
                      onClick={() =>
                        setVisible({ ...visible, selectPicChecker: true })
                      }
                    >
                      <div className="d-flex gap-2 align-items-center">
                        <div
                          className="d-flex align-items-center justify-content-center rounded"
                          style={{
                            width: '24px',
                            height: '24px',
                            backgroundColor: 'rgba(248, 157, 29, 0.1)'
                          }}
                        >
                          <Plus
                            size={12}
                            style={{
                              color: 'var(--primary-orange)'
                            }}
                          />
                        </div>
                        <span
                          className="fw-bold"
                          style={{ color: 'var(--primary-orange)' }}
                        >
                          Select Checker and PIC
                        </span>
                      </div>
                    </button>
                  </div>
                </Col>
              </Row>
            )}
            <Table
              hover
              responsive
              style={{
                borderRadius: '8px',
                overflow: 'hidden',
                fontSize: '0.9rem'
              }}
            >
              <thead>
                <tr>
                  {columns.map((column) => {
                    return column.key !== 'checkbox' ? (
                      <th
                        className={`align-middle p-2 ${column.className}`}
                        key={column.key}
                        style={tableHeaderStyle}
                      >
                        <span>{column.label}</span>
                      </th>
                    ) : (
                      <th
                        className={`align-middle p-2 ${column.className}`}
                        key={column.key}
                        style={{ ...tableHeaderStyle, width: '50px' }}
                      >
                        <div className="d-flex justify-content-center">
                          <input
                            type="checkbox"
                            role="button"
                            className="staging-area form-check-input"
                            onChange={() => handleCheckbox()}
                            style={{ cursor: 'pointer' }}
                            checked={selectedRacks?.length === data?.length}
                          />
                        </div>
                      </th>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {data.length === 0 && (
                  <tr>
                    <td colSpan={columns.length} className="text-center p-4">
                      No data found
                    </td>
                  </tr>
                )}
                {data.length > 0 &&
                  data.map((item, index) => (
                    <tr key={index}>
                      {columns.map((column) => (
                        <td key={column.key} className="p-2 align-middle">
                          {column.component && column.component(item)}
                          {column.key !== 'action' &&
                            !column.component &&
                            (item[column.key] ?? '-')}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </Table>
            <div className="mt-3">
              <p className="mb-0">
                <span className="fw-bold">Total Layer:</span>
                <span className="fw-bold text-danger ms-2">
                  {data?.length ?? 0}
                </span>
              </p>
            </div>
          </Col>
        </Row>
      </Card>
      <ModalStockAdjustment
        show={visible[ModalPropMemo?.key]}
        onHide={() => handleCloseModal(ModalPropMemo?.key)}
        size="md"
        title={ModalPropMemo?.headerTitle}
        backdrop="static"
      >
        <Modal.Body
          style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}
        >
          <>
            {ModalPropMemo?.key !== 'selectPicChecker' ? (
              <div className="d-flex justify-content-center py-2 my-2">
                <div className="d-flex flex-column justify-content-center">
                  <div className="d-flex justify-content-center">
                    <AlertIcon width={131} height={130} />
                  </div>
                  <div className="text-center my-3">
                    <h6 style={{ fontSize: '15px' }}>{ModalPropMemo?.title}</h6>
                    <p style={{ fontSize: '12px' }} className="fw-bold">
                      {ModalPropMemo?.body}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="my-2 p-2 ms-2">
                <p>
                  <span className="text-muted mr-2">for </span>
                  <span className="fw-bold">{getRackNameSelected || ''}</span>
                </p>
                <SelectInput
                  id="modal-pic"
                  handleChange={(e) =>
                    setSelectedForm({ ...selectedForm, pic: e.target.value })
                  }
                  label={'PIC'}
                  options={options?.pics || []}
                  value={selectedForm?.pic || ''}
                />
                <SelectInput
                  id="modal-checker"
                  handleChange={(e) =>
                    setSelectedForm({
                      ...selectedForm,
                      checker: e.target.value
                    })
                  }
                  label={'checker'}
                  options={options?.checkers || []}
                  value={selectedForm?.checker || ''}
                />
              </div>
            )}
            <Modal.Footer className="mt-3">
              {ModalPropMemo?.key !== 'selectPicChecker' ? (
                <>
                  <CustomCloseButton {...propertyBtnCancel()} />
                  <CustomButton {...propertyBtnSubmit()} />
                </>
              ) : (
                <div className="d-flex gap-2">
                  <Button
                    variant="transparent"
                    className={`${
                      !selectedForm?.pic || !selectedForm?.checker
                        ? 'btn-secondary opacity-25'
                        : 'btn-primary-orange'
                    }`}
                    onClick={() => handlingSavingBulk()}
                    disabled={!selectedForm?.pic || !selectedForm?.checker}
                  >
                    SAVE
                  </Button>
                </div>
              )}
            </Modal.Footer>
          </>
        </Modal.Body>
      </ModalStockAdjustment>
    </Container>
  )
}

export default CreateStockTake
